import type { StyleConfig } from "@chakra-ui/theme-tools"

/**
 * @see https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/link.ts
 */
export const Link: StyleConfig = {
  sizes: {
    sm: {
      fontSize: "14",
    },
    md: {
      fontSize: "16",
    },
    lg: {
      fontSize: "18",
    },
  },
  variants: {
    regular: {
      display: "inline-block",
      color: "main.700",
      _hover: {
        textDecoration: "underline",
      },
      _focus: {
        textDecoration: "underline",
      },
    },
    classic: {
      display: "inline-block",
      textDecoration: "underline",
      _hover: {
        color: "main.700",
      },
      _focus: {
        color: "main.700",
      },
    },
    underline: {
      textDecoration: "underline",
      _hover: {
        textDecoration: "none",
      },
      _focus: {
        textDecoration: "none",
      },
    },
    emphasized: {
      position: "relative",
      display: "inline-block",
      fontWeight: 600,
      color: "main.700",
      _hover: {
        textDecoration: "none",
        _before: {
          height: "4px",
        },
      },
      _focus: {
        textDecoration: "none",
        _before: {
          height: "4px",
        },
      },
      _before: {
        content: "''",
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        height: "1px",
        transition: "height .1s ease 0s",
        background: "main.700",
      },
    },
  },
  defaultProps: {
    variant: "regular",
  },
}
